export default __webpack_public_path__ + "static/media/data-step-image-desktop.9aa3f115.png";